import React, { useState, useEffect } from 'react';
import SendMessageButton from './SendMessageButton';
import Groups, { Group } from './Groups';
import './MainPage.css';

const MainPage = () => {

    const [selectedGroups, setSelectedGroups] = useState<Group[]>([]);

    useEffect(() => {
        // Reset zoom level to 1 when transitioning to this page
        document.querySelector('meta[name=viewport]')!.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
    }, []);

    return (
        <div className="main-page">
            <h3>Create groups of your friends below storing their phone numbers. Select a group (or more) & search for the location where you want to meet. Then press send message below to notify them!</h3>
            <Groups selectedGroups={selectedGroups} setSelectedGroups={setSelectedGroups} />
            <SendMessageButton selectedGroups={selectedGroups} />
        </div>
    );
};

export default MainPage;
